<fd-message-strip
  [type]="'error'"
  [noIcon]="true"
  [dismissible]="false"
  style="margin-top: 15px; margin-bottom: 15px"
  width="{{ width }}"
>
  <div class="wrapper">
    <div class="strip-content">
      <span class="main-error-text">{{ errorText || errorMsg }}</span>
      @if (!!errorMsg && !!errorText) {
        @if (!errorMsgShown) {
          <span
            class="view-error-details"
            href="#"
            (click)="viewErrorDetails(errorMsg)"
            >View Details</span
          >
        }
        @if (errorMsgShown) {
          <span class="hide-error-details" href="#" (click)="hideErrorDetails()"
            >Hide Details</span
          >
        }
        @if (errorMsgShown) {
          <div class="view-error-details-inline">{{ errorMsg }}</div>
        }
      }
    </div>
    <div class="additional-content">
      <ng-container *ngTemplateOutlet="additionalContent"></ng-container>
    </div>
  </div>
</fd-message-strip>
